import { render, staticRenderFns } from "./registrations-list.vue?vue&type=template&id=e1c0ed48"
import script from "./registrations-list.vue?vue&type=script&lang=js"
export * from "./registrations-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports